var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('field-access-icon',{attrs:{"field":_vm.field,"is-manager":_vm.isManager}}),_vm._v(" "),_c('div',{directives:[{name:"output",rawName:"v-output",value:(_vm.content),expression:"content"}]})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }